import React, { useState } from 'react'
import { Form, Input, Upload, Row, Space } from 'antd'
import { ButtonUploadDiv } from '../../../pages/SignupBin/AddBin'
import AddIcon from '../../../assets/icons/Add_image.png'
import { LocationSignUp } from '../../../components/LocationSignUp'
import { isEmpty } from 'lodash'
import axios from 'axios'
import { beforeUpload, compressFile } from '../../../utils'
import { ButtonEx } from '../../HeroLocations/index.style'
import { FormItem } from '../../../shared.style'

const AddLocation = ({ setFormData, setPage, formData }) => {
  const [fileBinList, setFileBinList] = useState([])
  const [locations, setLocations] = useState([])
  const [binImage, setBinImage] = useState(null)

  const heroConfig = {
    radius: 5000,
    locationCount: 1
  }

  const handleSetLocations = async (location) => {
    await setLocations((prevState) => {
      prevState.splice(1, 0, location)
      return [...prevState]
    })
  }

  const handleSetDeleteLocations = async (id) => {
    await setLocations((prevState) => {
      prevState.splice(id, 1)
      return [...prevState]
    })

    await localStorage.removeItem('location-data')
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  const handleChange = async (info) => {
    const formData = new FormData()
    if (!isEmpty(info.fileList)) {
      formData.append('image', await compressFile(info.file))
      setFileBinList(info.fileList)
      try {
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
          formData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )

        const { data } = res
        setBinImage(data.url)
      } catch (err) {
        console.log(err)
      }
    } else {
      setFileBinList(info.fileList)
    }
  }

  const onBack = () => {
    setPage('1')
  }

  const onFinish = async (values) => {
    const location = locations[0]
    const data = {
      ...formData,
      lat: location.lat,
      lng: location.lng,
      locationImage: binImage,
      locationName: values.locationName
    }

    await setFormData(data)
    await setPage('3')
  }

  return (
    <Form onFinish={onFinish} layout="vertical">
      <FormItem
        name="circularBin"
        label="รูปภาพสถานที่ตั้ง หรือจุดวาง Circular Bin"
        valuePropName="fileList"
        rules={[
          {
            required: true,
            message: 'เลือกรูปภาพ Circular Bin'
          }
        ]}
        getValueFromEvent={normFile}>
        <Upload
          name="circularBinImg"
          listType="picture"
          fileList={fileBinList}
          maxCount={1}
          beforeUpload={beforeUpload}
          onChange={handleChange}>
          {isEmpty(fileBinList) && (
            <ButtonUploadDiv>
              <img src={AddIcon} alt="" width={80} height={80} />
            </ButtonUploadDiv>
          )}
        </Upload>
      </FormItem>
      <Form.Item
        name="locationName"
        label="ชื่อสถานที่ตั้ง Circular Bin"
        rules={[
          {
            required: true,
            message: 'กรอกชื่อสถานที่'
          }
        ]}>
        <Input />
      </Form.Item>
      <LocationSignUp
        locations={locations}
        heroConfig={heroConfig}
        handleSetLocations={handleSetLocations}
        handleSetDeleteLocations={handleSetDeleteLocations}
      />
      <Row justify="center" style={{ marginTop: 15 }}>
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => onBack()}>
            ย้อนกลับ
          </ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            ต่อไป
          </ButtonEx>
        </Space>
      </Row>
    </Form>
  )
}

export default AddLocation



// WEBPACK FOOTER //
// ./src/pages/SignupBin/AddLocation/index.js